import React from 'react'

interface TestIdProps {
  className?: string
  testId: string | null
}

// TODO: add this to the shared component library
const TestId: React.FC<React.PropsWithChildren<TestIdProps>> = (props) => (
  <div className={props.className} data-testid={props.testId}>
    {props.children}
  </div>
)

export default TestId
